import {
  type ComponentType as ReactComponentType,
  forwardRef,
  type ForwardRefExoticComponent,
} from 'react';

export type ContainerComponentProps<Props> = Props extends Props
  ? Omit<Props, 'dangerouslyOverrideClassName'> & { className?: string }
  : never;

export function withClassNameHoc<
  P extends {
    dangerouslyOverrideClassName?: { __className?: string };
  },
>(Component: ReactComponentType<P> | ForwardRefExoticComponent<P>) {
  const hoc = forwardRef<unknown, ContainerComponentProps<P>>((props, ref) => {
    const { className, ...remaining } = props;
    const rest = remaining as unknown as P;

    if (className) {
      rest.dangerouslyOverrideClassName = { __className: className };
    }

    return <Component ref={ref} {...rest} />;
  });

  hoc.displayName = `withClassNameHoc(${Component?.displayName || Component?.name || 'Component'})`;

  return hoc;
}
